// gatsby-browser.js
import React from "react";
import GlobalProvider from "./src/contexts/globalProvider";
import './src/styles/global.css';

export const onClientEntry = () => {
    if (typeof document !== 'undefined') {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.comfama.com/comfama-ui/icons/icons.css?v2';
        document.head.appendChild(link);
    }
};

export const wrapRootElement = ({ element }) => {
  return <GlobalProvider>{element}</GlobalProvider>;
};
